module.exports = __webpack_public_path__ + "img/image_4.13ba0303.png";